import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { CircularProgress, ButtonBaseProps } from '@material-ui/core';
import { getColors } from '@styles/colorsTheme';
interface IButtonProps extends ButtonBaseProps {
  loading?: boolean;
  color: 'primary' | 'secondary' | 'inherit' | 'default' | undefined | 'tertiary' | 'quartenary' | 'quinary';
  disabledColor?: string;
  fullWidth?: boolean;
}

const ButtonComponent: React.FC<IButtonProps> = ({
  loading,
  color,
  children,
  disabledColor,
  fullWidth,
  ...rest
}) => {
  const CssButton = withStyles({
    root: {
      height: 50,
      fontSize: 17,
      fontFamily: 'Poppins, sans-serif',
      lineHeight: 1,
      textAlign: 'left',
      paddingLeft: 20,
      fontWeight: 'bold',
      width: 250,
      textTransform: 'none',
      backgroundColor:
        color === 'primary'
          ? getColors().azulClaro
          : color === 'secondary'
          ? getColors().azulEscuro
          : color === 'tertiary'
          ? getColors().vermelho
          : color === 'quartenary'
          ? getColors().gold
          : color === 'quinary'
          ? getColors().azulUnico
          : color === 'default'
          ? getColors().cinzaEscuro
          : getColors().cinzaClaro,
      color: getColors()?.azulUnico,
      borderRadius: 50,
      borderColor: '#000',
      '&:disabled': {
        backgroundColor: disabledColor ? disabledColor : '#84c5f080',
      },
    },
  })(Button);

  return (
    <CssButton
      variant="contained"
      disableElevation
      fullWidth={fullWidth}
      size="small"
      style={{ color: getColors()?.azulEscuro }}
      disabled={loading}
      {...rest}
    >
      {!loading ? children : <CircularProgress color="secondary" size={15} />}
    </CssButton>
  );
};

export default ButtonComponent;
